import type { DateRangePreset } from '@/pages/dashboard/utils/dateRangeUtils'
import moment from 'moment'

const PRESETS: { id: Exclude<DateRangePreset, 'custom'>; label: string }[] = [
	{ id: '7', label: '7 days' },
	{ id: '30', label: '30 days' },
	{ id: '90', label: '90 days' },
]

type DashboardDateFilterProps = {
	preset: DateRangePreset
	dateFrom: string
	dateTo: string
	onPresetClick: (id: Exclude<DateRangePreset, 'custom'>) => void
	onDateFromChange: (value: string) => void
	onDateToChange: (value: string) => void
	onApply: () => void
}

export function DashboardDateFilter({
	preset,
	dateFrom,
	dateTo,
	onPresetClick,
	onDateFromChange,
	onDateToChange,
	onApply,
}: DashboardDateFilterProps) {
	return (
		<div className="flex flex-wrap items-end gap-3 rounded-xl border border-border/60 bg-background/50 p-3">
			<div className="flex flex-wrap gap-2">
				{PRESETS.map((item) => (
					<button
						key={item.id}
						type="button"
						onClick={() => onPresetClick(item.id)}
						className={`rounded-full px-3.5 py-1.5 text-sm font-semibold transition-all ${
							preset === item.id
								? 'bg-primary text-primary-foreground shadow-sm'
								: 'border border-border/70 bg-card text-foreground hover:border-primary/30 hover:bg-primary/5'
						}`}
					>
						{item.label}
					</button>
				))}
			</div>
			<div className="flex flex-wrap items-end gap-2 sm:ml-auto">
				<div>
					<label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">From</label>
					<input
						type="date"
						className="form-input h-9 min-w-[140px] rounded-lg border-border bg-background text-sm"
						value={dateFrom}
						max={dateTo || undefined}
						onChange={(e) => onDateFromChange(e.target.value)}
					/>
				</div>
				<div>
					<label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">To</label>
					<input
						type="date"
						className="form-input h-9 min-w-[140px] rounded-lg border-border bg-background text-sm"
						value={dateTo}
						min={dateFrom || undefined}
						max={moment().format('YYYY-MM-DD')}
						onChange={(e) => onDateToChange(e.target.value)}
					/>
				</div>
				<button
					type="button"
					onClick={onApply}
					disabled={!dateFrom || !dateTo || moment(dateFrom).isAfter(dateTo)}
					className="h-9 rounded-lg bg-primary px-4 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
				>
					Apply
				</button>
			</div>
		</div>
	)
}
